import { DesignProp } from "../PropCategories";

export const backgroundImage = {
  prop: "style-attribute",
  name: "Background Image",
  nameI18n: "builder_ui.prop_type.styles.background_image",
  category: [DesignProp],
  type: "background-image",
  defaultValue: {
    placeholder: "",
    signed_id: "",
  },
  shouldAllowRemovingImage: true,
} as const;
